import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TsplatShowRingsIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21.9 2.10001C18.33 -1.46999 11.19 0.0900054 5.64001 5.64001C0.0900054 11.19 -1.46999 18.33 2.10001 21.9C3.39001 23.19 5.16001 23.82 7.15001 23.82C10.64 23.82 14.83 21.91 18.36 18.37C23.91 12.82 25.46 5.67001 21.9 2.11001V2.10001ZM16.95 16.95C12.35 21.55 6.20001 23.17 3.51001 20.49C0.830005 17.81 2.45001 11.65 7.05001 7.05001C10.14 3.96001 13.93 2.22001 16.9 2.22001C18.35 2.22001 19.61 2.64001 20.49 3.52001C23.17 6.20001 21.55 12.36 16.95 16.96V16.95Z"
        fill={color}
      />
      <path
        d="M13.76 5.28999C12.05 5.85999 10.23 7.04999 8.64 8.63999C5.17 12.11 3.93 16.3 5.81 18.19C6.4 18.78 7.23 19.07 8.19 19.07C10.27 19.07 12.98 17.74 15.36 15.36C16.95 13.77 18.14 11.95 18.71 10.24C19.34 8.34999 19.15 6.77999 18.19 5.81999C17.23 4.85999 15.65 4.66999 13.77 5.29999L13.76 5.28999ZM17.29 9.75999C16.79 11.25 15.73 12.86 14.3 14.3C11.28 17.32 7.96 18.22 6.88 17.13C5.79 16.04 6.69 12.73 9.71 9.69999C11.14 8.26999 12.75 7.20999 14.25 6.70999C15.55 6.27999 16.6 6.33999 17.14 6.86999C17.68 7.40999 17.74 8.45999 17.3 9.75999H17.29Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TsplatShowRingsIcon.displayName = 'TsplatShowRingsIcon';
